import { motion } from "framer-motion";

/**
 * Consistent section header used across the site.
 * Small eyebrow + large display title. No "chapter numbers".
 */
export default function SectionHeader({
  eyebrow,
  title,
  intro,
  invert = false,
  align = "split", // "split" (2-col) or "center"
}) {
  const textCol = invert
    ? "text-[color:var(--paper)]"
    : "text-[color:var(--ink)]";
  const dim = invert
    ? "text-[color:var(--paper)]/70"
    : "text-[color:var(--ink)]/70";
  const accent = invert
    ? "text-[color:var(--sand)]"
    : "text-[color:var(--forest)]/70";

  if (align === "center") {
    return (
      <div className={`text-center max-w-3xl mx-auto ${textCol}`}>
        <div className={`font-mono-alt ${accent} mb-3`}>{eyebrow}</div>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.9, 0.2, 1] }}
          className="font-display text-[clamp(1.9rem,3.6vw,3rem)] leading-[1.05] tracking-tight"
        >
          {title}
        </motion.h2>
        {intro && (
          <p className={`mt-4 ${dim} text-[0.98rem] leading-relaxed`}>{intro}</p>
        )}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-12 gap-6 items-end ${textCol}`}>
      <div className="col-span-12 md:col-span-5">
        <div className={`font-mono-alt ${accent} mb-3`}>{eyebrow}</div>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.9, 0.2, 1] }}
          className="font-display text-[clamp(1.9rem,3.6vw,3rem)] leading-[1.05] tracking-tight"
        >
          {title}
        </motion.h2>
      </div>
      {intro && (
        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <p className={`${dim} max-w-md`}>{intro}</p>
        </div>
      )}
    </div>
  );
}
